export default __webpack_public_path__ + "static/addy-e5c48c65c036f8468666e99009d11b0d.svg";